import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

import { Grid } from '@material-ui/core';

import Accordion from '../../../../components/Accordion';
import Select from '../../../../components/Inputs/Select';
import Input from '../../../../components/Inputs/Input';
import StepProgress from '../../../../components/StepProgress';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import CardDocument from '../../../../components/Cards/Document';
import FileViewer from '../../../../components/FileViewer';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import Alert from '../../../../components/Alert';
import FormContainer from '../../../../components/FormContainer';

import { alterarBeneficiario, getGrauParentesco, getCongenerByContractAndPlanAndUfAndCity } from '../../../../services';
import { getCongenerByContractAndPlan } from '../../../../services/v3/contrato-congenere';

import { base64toBlob, cloneObject, handleTopCritics, addTimeToNameFile, checkIsSupport } from '../../../../utils';
import steps from '../../../../utils/steps.json';
import validate from '../../../../utils/validateForm';
import validators from '../../../../utils/defaultValidators';

import schema from './schema';
import translateToSchema from './translate';

import { PageContainer, ContainerButton } from '../../../../styles/styles';
import { EmptyField } from '../../../../components/Inputs/styles';

import { useGlobal } from '../../../../contexts/Global/context';
import regexps from '../../../../utils/regexps';

function Dependente({ location: { dataBeneficiario, dataTitular, criticas = [] } }) {
    const history = useHistory();
    const { dataActiveContract, staticOptions, setShowSupportModal } = useGlobal();

    const translatedData = dataBeneficiario && translateToSchema(dataBeneficiario);

    const [dataForm, setDataForm] = useState(translatedData ? cloneObject(translatedData) : cloneObject(schema));
    const [loadingPost, setLoadingPost] = useState(false);
    const [dataMovimentacao, setDataMovimentacao] = useState({});
    const [alerts, setAlerts] = useState(criticas);
    const [showModal, setShowModal] = useState(false);
    const [showModalCpfExistente] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [othersDocuments, setOthersDocuments] = useState([]);
    const [cpfLoading] = useState(false);

    const [hasCpfTitular, setHasCpfTitular] = useState(true);

    useEffect(() => {
        if (
            dataTitular?.cpf === '' ||
            dataTitular?.cpf === undefined ||
            dataTitular?.cpf === 0 ||
            dataTitular?.cpf === '00000000000' ||
            dataTitular?.numCarteirinha === undefined ||
            dataTitular?.nomeCompleto === undefined
        ) {
            setHasCpfTitular(false);
        }
    }, []);

    async function updateCongenerName() {
        if (!dataForm.stateService?.value || !dataForm.countyService?.value) {
            return;
        }

        const congenerName = cloneObject(dataForm.congenerName);

        let results;

        if (dataForm?.stateService.value && dataForm?.countyService.value) {
            results = await getCongenerByContractAndPlanAndUfAndCity({
                numeroContrato: dataActiveContract?.numero,
                codigoPlano: dataBeneficiario?.plano.planoSaude,
                siglaUf: dataForm?.stateService.value,
                codigoMunicipio: dataForm?.countyService.value,
            });
        } else {
            results = await getCongenerByContractAndPlan({
                numeroContrato: dataActiveContract?.numero,
                codigoPlano: dataBeneficiario?.plano.planoSaude,
            });
        }

        if (results?.results?.length) results = results.results;

        if (results[0]) {
            congenerName.value = results[0].nomeFantasiaCongenere || '';
            setDataForm((current) => ({ ...current, congenerName }));
        }
    }

    useEffect(() => {
        if (dataForm?.stateService.value && dataForm?.countyService.value) updateCongenerName();
    }, [dataForm?.stateService.value, dataForm?.countyService.value]);

    function handleShowModal(file) {
        const extArquivo = file.name.split('.')[1];

        const mode = ['jpeg', 'jpg', 'png', 'svg'].includes(extArquivo.toLowerCase()) ? 'image' : 'application';

        const blob = base64toBlob(file.base64, `${mode}/${extArquivo}`);
        const blobUrl = URL.createObjectURL(blob);

        setModalInfo({
            title: file.name,
            content: <FileViewer fileExtension={extArquivo} src={blobUrl} base64={file.base64} />,
        });

        setShowModal(true);
    }

    function handleInputBlur(event) {
        const { id, name, value } = event.target;
        const key = id || name;

        const form = cloneObject(dataForm);

        // Valida as regras de negocio do campo e, caso haja erro, altera o indice error
        if (typeof validators[key] === 'function') validators[key](form);

        if (key === 'birth' && value) {
            form.dn.error = '';

            if (form.dn.value) validators.dn(form);
        }

        // Valida os campos obrigatorios sem valores
        if (form[key].required && !value) {
            form[key].error = form[key].requiredMessage || 'Preencha com um valor válido.';
        }

        setDataForm({ ...form });
    }

    async function handleChangeInput(event) {
        const { id, value, unmaskedValue, lookup } = event;

        const field = { ...cloneObject(dataForm[id]), value, lookup, unmaskedValue, error: '' };

        const newDataForm = {
            ...dataForm,
            [id]: field,
        };

        setDataForm(newDataForm);
    }

    function handleFileChange({ event, id }) {
        if (!event.target.files) return;

        const reader = new FileReader();
        const file = event.target.files[0];

        reader.onloadend = () => {
            const { name: fileName, size: fileSize } = file;
            const base64 = reader.result.split(',')[1];

            const fileNameFiltered = fileName.replace(regexps.charRemove, "");

            // Limpa o input de arquivo
            // eslint-disable-next-line no-param-reassign
            event.target.value = null;

            const acceptedFormats = ['jpeg', 'jpg', 'png', 'pdf', 'svg'];

            const fileExtention = fileNameFiltered.substring(fileNameFiltered.lastIndexOf('.') + 1);
            if (!acceptedFormats.includes(fileExtention.toLowerCase())) return;

            const dataDocument = {
                id,
                base64,
                name: addTimeToNameFile(fileNameFiltered, fileExtention),
                size: `${(fileSize / 1024).toFixed(2)}Kb`,
            };

            const documents = cloneObject(othersDocuments);

            const foundDocument = documents.filter((document) => document.id === id && document.name === fileNameFiltered);
            if (foundDocument.length) return;

            documents.push(dataDocument);

            setOthersDocuments([...documents]);
        };

        reader.readAsDataURL(file);
    }

    function handleFileDelete({ id, fileName }) {
        let documents = cloneObject(othersDocuments);

        documents = documents.filter((document) => document.id === id && document.name !== fileName);

        setOthersDocuments([...documents]);
    }

    async function handleSendDataDependente() {
        const { validatedForm, isValid } = validate(dataForm);

        setDataForm({
            ...dataForm,
            ...validatedForm,
        });

        if (!isValid) {
            setTimeout(() => {
                const firstElementWithError = document.querySelector('.error');

                if (firstElementWithError) {
                    firstElementWithError.scrollIntoView({ block: 'center', behavior: 'smooth' });
                }
            }, 100);

            setLoadingPost(false);

            return;
        }

        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        setLoadingPost(true);

        const payload = {
            ...dataMovimentacao,
            numeroContrato: dataBeneficiario.contrato.numero,
            numeroAssociadoOuNumeroCarteira: dataBeneficiario.numCarteira,
            nomeAssociado: dataForm.fullName.value,
            numeroCPF: dataForm.cpf.unmaskedValue,
            numeroSequencialMatricula: dataForm.enrollmentSequence.value,
            numeroMatriculaNaEmpresa: dataForm.functionalEnrollment.value,
            tipoAssociado: 'D',
            nacionalidade: 'B',
            nomeSocial: dataForm.socialName.value,
            dataNascimento: dataForm.birth.value,
            sexo: dataForm.gender.value,
            codigoDependencia: +dataForm.kinshipDegree.value,
            nomeMae: dataForm.motherName.value,
            numeroUnicoSaude: dataForm.sus.value && dataForm.sus.value.replace(/\W/g, ''),
            estadoCivil: dataForm.civilState.value,
            numeroPIS: dataForm.pis.unmaskedValue,
            numeroDeclaracaoNascidoVivo: dataForm.dn.value,
            anexos: othersDocuments.map((doc) => ({ NomeArquivo: doc.name, Base64Arquivo: doc.base64 })),
            referenciaMovimentacao: dataActiveContract.referenciaMovimentacao?.dataReferenciaMovimentacao,
        };

        const response = await alterarBeneficiario(payload);

        if (response.errorDescription) {
            response.movimentacoes = [
                {
                    criticas: [
                        {
                            tipo: 1,
                            descricao: response.errorDescription,
                        },
                    ],
                },
            ];
        }

        const movimentacao = response?.movimentacoes[0] || {};
        const handledAlerts = handleTopCritics(movimentacao.criticas);

        if (handledAlerts?.length > 0) {
            setAlerts([...handledAlerts]);

            setDataMovimentacao({
                sequencialMovimentacao: movimentacao.sequencialMovimentacao,
                codigoSituacaoMovimentacao: movimentacao.codigoSituacaoMovimentacao,
            });

            setTimeout(() => {
                window.document.getElementById('page-content').scrollTo(0, 0);
            }, 100);

            setLoadingPost(false);

            return;
        }

        history.push('/movimentacao_cadastral/validar_alteracao_beneficiario');
    }

    useEffect(() => {
        if (!dataBeneficiario) history.push('/movimentacao_cadastral/selecionar_alterar_beneficiario');

        async function loadDataContrato() {
            const { contrato, plano } = dataBeneficiario || {};

            const parentescos = await getGrauParentesco(
                plano?.planoSaude,
                contrato?.numero,
                moment(dataActiveContract?.dataUltimaVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD')
            );

            const initialValues = {
                kinshipDegree: { ...dataForm.kinshipDegree, options: parentescos },
                civilState: { ...dataForm.civilState, options: staticOptions.estadoCivil },
                enrollmentSequence: {
                    ...dataForm.enrollmentSequence,
                    required: dataActiveContract.parametros?.obrigatorioInformarSequencialMatriculaFuncional,
                },
            };

            setDataForm({
                ...dataForm,
                ...initialValues,
            });
        }

        loadDataContrato();
    }, []);

    return (
        <PageContainer>
            <StepProgress steps={steps.alterarBeneficiario} activeStep={2} />

            {alerts.map((alert, index) => (
                <Alert key={() => index} type={alert.tipo} title={alert.descricao} message={alert.complemento} />
            ))}

            {hasCpfTitular ? (
                <Accordion title="Dados de titular">
                    <FormContainer>
                        <Input
                            field={{
                                id: 'carteirinha',
                                label: 'N° da carteirinha',
                                value: dataTitular?.numCarteirinha || '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'nomeCompleto',
                                label: 'Nome completo',
                                value: dataTitular?.nomeCompleto || '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'contrato',
                                label: 'Contrato',
                                value:
                                    (dataTitular?.contrato?.numero &&
                                        `${dataTitular?.contrato?.numero} - ${dataTitular?.contrato?.nome}`) ||
                                    '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'empresa',
                                label: 'Empresa',
                                value: dataTitular?.empresa || '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'healthPlan',
                                label: dataActiveContract.isDental ? 'Plano Dental' : 'Plano de saúde',
                                value: dataTitular?.planoSaude?.nome || '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'dateStartPlan',
                                label: 'Data de início do plano',
                                value:
                                    (dataTitular?.planoSaude?.dataInicio &&
                                        moment(dataTitular?.planoSaude?.dataInicio).format('DD/MM/YYYY')) ||
                                    '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'stateService',
                                label: 'Estado de atendimento',
                                value: dataForm?.stateService?.value || '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'countyService',
                                label: 'Município de atendimento',
                                value: dataForm?.countyService?.lookup || '',
                                disabled: true,
                            }}
                        />
                        <Input
                            field={{
                                id: 'titularEnrollment',
                                label: dataForm.functionalEnrollment.label,
                                value: dataTitular?.matriculaFuncional || '',
                                disabled: true,
                            }}
                        />
                        {dataForm?.congenerName?.value && (
                            <Input
                                field={{
                                    id: 'congenerName',
                                    label: 'Congênere',
                                    value: dataForm?.congenerName?.value || '',
                                    disabled: true,
                                }}
                            />
                        )}
                    </FormContainer>
                </Accordion>
            ) : null}

            <Accordion title={`Dados de ${dataBeneficiario?.tipo?.toLowerCase()}`}>
                <FormContainer>
                    <Input
                        field={{
                            ...dataForm.cpf,
                            loading: cpfLoading,
                        }}
                        onBlur={handleInputBlur}
                        onChange={handleChangeInput}
                    />
                    <EmptyField />
                    <Input field={dataForm.fullName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.socialName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui field={dataForm.birth} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.gender} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.motherName} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.civilState} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Select field={dataForm.kinshipDegree} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <DatepickerMui field={dataForm.weddingDate} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.pis} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.sus} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.dn} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.enrollmentSequence} onBlur={handleInputBlur} onChange={handleChangeInput} />
                    <Input field={dataForm.functionalEnrollment} />
                </FormContainer>
            </Accordion>

            <Accordion title="Documentos">
                <Alert
                    type={4}
                    title="Se você quiser, compartilhe com a gente um documento comprobatório dos dados que você alterou no formulário."
                />

                <CardDocument
                    id={-1}
                    name="Documentos"
                    files={othersDocuments}
                    isOthers
                    onFileChange={(event) => handleFileChange({ event, id: -1, isOthers: true })}
                    onDeleteFile={handleFileDelete}
                    onClickViewFile={(dataFileClicked) => handleShowModal({ ...dataFileClicked })}
                />
            </Accordion>

            <ContainerButton style={{ marginTop: 10 }}>
                <Button id="backStep" type="secondary" onClick={() => history.goBack()}>
                    Voltar
                </Button>

                <Button
                    id="continueStep"
                    type="primary"
                    loading={loadingPost}
                    onClick={handleSendDataDependente}
                    disabled={loadingPost}
                >
                    Finalizar
                </Button>
            </ContainerButton>

            <Modal
                title={modalInfo.title}
                subtitle={modalInfo.content}
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                {modalInfo.backButton && (
                    <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                        <Button type="primary" onClick={() => setShowModal(false)}>
                            Voltar
                        </Button>
                    </Grid>
                )}
            </Modal>

            <Modal
                title="Atenção"
                visible={showModalCpfExistente}
                closable={false}
                onCancel={() => setShowModal(false)}
                footer={null}
                style={{ width: '40%' }}
            >
                Este CPF já está cadastrado no sistema. Adicione outro para o novo beneficiário.
                <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                    <Button type="primary" style={{ marginTop: '20px' }} onClick={() => setShowModal(false)}>
                        Revisar
                    </Button>
                </Grid>
            </Modal>
        </PageContainer>
    );
}

export default Dependente;
